export const isDev = () =>
  process.env.NODE_ENV === 'development' ||
  ['development', 'preview', 'local'].includes(process.env.NEXT_PUBLIC_VERCEL_ENV || '')
